import { Pipe, PipeTransform } from '@angular/core';

import { AbstractTableWidgetComponent } from '../modules/widget/components/widget/abstract-table-widget.component';
import { WidgetGridOptions } from '../modules/widget/components/widget-grid/widget-grid.component';

@Pipe({
  name: 'cellComment',
  pure: false,
  standalone: false,
})
export class CellCommentPipe implements PipeTransform {
  transform(value: any, widget: AbstractTableWidgetComponent<WidgetGridOptions>): any {
    return widget.getCellComments(value);
  }
}
